import * as React from 'react'
import { connect } from 'react-redux'
import { actions } from 'react-redux-form'

import { SRPRS } from 'components/_Assets/svg/Icon/srprs'
import { ActionList } from 'components/ActionList'
import Box, { BoxType } from 'components/Box'
import { Button, TYPE } from 'components/Button'
import Heading from 'components/Heading'
import Hero from 'components/Hero'
import { HeroType } from 'components/Hero/Hero'
import { InfoBox, InfoBoxItem } from 'components/InfoBox/InfoBox'
import { List, ListItem } from 'components/List'
import ListHeader from 'components/ListHeader'
import Section, { SectionType, Size } from 'components/Section/Section'
import Style from 'components/Style'
import { Timeline, TimelineItem } from 'components/Timeline'
import { Colour } from 'components/variables'
import { getCdnUrl } from '../../data/api/cdn'
import { EntryProps } from '../../data/entries/types'
import { City } from '../../data/models/funnelOrder/cities'
import { inControlOptions } from '../../data/models/funnelOrder/days'
import { destinationEnum } from '../../data/models/funnelOrder/destination'
import { Theme } from '../../data/models/funnelOrder/theme'
import { SiteCountry } from '../../data/models/locale'
import { AppState } from '../../data/state'
import { FunnelStep } from '../../data/ui'
import Calendar from '../../elements/Calendar'
import IfCountry from '../../elements/conditionals/IfCountry'
import FlyExcludedCities from '../../elements/excluded/FlyExcludedCities'
import FunnelFooter from '../../elements/footers/funnelFooter'
import FunnelBreadcrumbs from '../../elements/FunnelBreadcrumbs'
import GiftcardModal from '../../elements/modals/GiftcardModal'
import PersonModal from '../../elements/modals/PersonModal'
import NewCitiesTrigger from '../../elements/triggers/new-cities/NewCitiesTrigger'
import { getNameWithTheme, getParamsWithTheme } from '../../routing/links'
import AirportComponent from '../funnel/customise/options/airport'
import Airport from '../funnel/customise/options/airport'
import Days from '../funnel/customise/options/days'
import People from '../funnel/customise/options/people'
import RoomType from '../funnel/customise/options/roomType'
import { QueryKey } from '../funnel/customise/wrapper'
import {
  CustomiseWrapperInnerProps,
  withAirportsAndPrices,
} from '../funnel/customise/wrapperFunction'
import DisplayContent from '../shared/content'
import Page from '../shared/page_wrapper'
import BasicInfo from './components/basicInfo'
import Countdown from './components/countdown'
import HowItWorks from './components/entries/howItWorks'
import FAQ from './components/faq'
import FlavourBox from './components/flavourBox'

interface InControlProps extends EntryProps {
  destination: destinationEnum
  total: number
  patternImage: string
  country: SiteCountry
  excludedCities: City[]
  setExcludedCities(cities: City[]): void
}

class InControlPage extends React.Component<
  InControlProps & CustomiseWrapperInnerProps
> {
  private infoSection?: HTMLDivElement
  private detailsSection?: HTMLDivElement

  public componentDidMount() {
    const hash = window.location.hash
    if (hash !== undefined && hash === '#steden') {
      setTimeout(() => {
        if (this.detailsSection) {
          this.detailsSection.scrollIntoView({
            behavior: 'smooth',
            block: 'start',
          })
        }
      }, 2000)
    } else {
      window.scrollTo(0, 0)
    }
  }

  public render() {
    const { entry, match, prices, loading, patternImage, airports } = this.props
    const pattern = getCdnUrl('Explore-New-Cities-spaghetti.png')

    if (entry.page === undefined) {
      throw new Error('No page properties')
    }

    return (
      <Page
        match={match}
        page={entry.page.name}
        color={entry.colour}
        navBarType="funnel"
        navBarOverrideColour={
          entry.page.style ? entry.page.style.navbarColor : undefined
        }
        navFooter
      >
        <Hero
          blurMobile
          type={HeroType.flavourEntry}
          headingColor={
            entry.page.style ? entry.page.style.headingColor : undefined
          }
          headingText={
            <DisplayContent contentKey="title">{entry.name}</DisplayContent>
          }
          subHeading={<FunnelBreadcrumbs funnelStep={FunnelStep.Customise} />}
          src={entry.page.photos.src}
          src1024={entry.page.photos.src1024}
          src1280={entry.page.photos.src1280}
          src1600={entry.page.photos.src1600}
          src1920={entry.page.photos.src1920}
        >
          <FunnelBreadcrumbs funnelStep={FunnelStep.Customise} />
          <Heading level={1}>
            <DisplayContent contentKey="title">{entry.name}</DisplayContent>
          </Heading>
          <InfoBox>
            <InfoBoxItem
              icon={SRPRS.calendarColored()}
              firstLine={
                <DisplayContent contentKey="1-info-top">3 - 14</DisplayContent>
              }
              secondLine={
                <DisplayContent contentKey="1-info-bottom">
                  Dagen
                </DisplayContent>
              }
            />
            <InfoBoxItem
              icon={
                entry.theme === Theme.fly
                  ? SRPRS.aeroplaneColored
                  : SRPRS.carColored
              }
              firstLine={
                <DisplayContent contentKey="2-info-top">2 tot 4</DisplayContent>
              }
              secondLine={
                <DisplayContent contentKey="2-info-bottom">
                  Steden
                </DisplayContent>
              }
            />
            <InfoBoxItem
              icon={SRPRS.mapMarkerColored}
              iconProps={{
                width: '37',
                height: '37',
                viewBox: '0 0 37 41',
                fill: 'none',
              }}
              firstLine={
                <DisplayContent contentKey="3-info-top">Heel</DisplayContent>
              }
              secondLine={
                <DisplayContent contentKey="3-info-bottom">
                  Europa
                </DisplayContent>
              }
            />
          </InfoBox>
        </Hero>
        <BasicInfo
          detailsScroll={this.handleDetailsScroll}
          infoScroll={this.handleInfoScroll}
        />
        {entry.expiry ? (
          <Countdown pattern={pattern} timestamp={entry.expiry} />
        ) : null}
        <Section type={SectionType.solid} size={Size.s}>
          <Style margin={[[0, 0, 20, 0]]}>
            <div ref={this.setDetailsRef} />
            <Timeline direction="vertical" numbers>
              <NewCitiesTrigger showLength={5}>
                <p>
                  <DisplayContent contentKey="over-5-cities">
                    Nice! You've already seen more of Europe than people who
                    have visited 4 cities. We will still succeed in finding a
                    city though, trust us
                  </DisplayContent>
                </p>
              </NewCitiesTrigger>
              <NewCitiesTrigger colour={Colour.mint} showLength={8}>
                <p>
                  <DisplayContent contentKey="over-8-cities">
                    Okay, okay, we get it. We can still send you to a new city,
                    but as you know; The more cities you add, the smaller the
                    surprise.
                  </DisplayContent>
                </p>
              </NewCitiesTrigger>
              <NewCitiesTrigger colour={Colour.pink} showLength={10}>
                <p>
                  <DisplayContent contentKey="over-10-cities">
                    Respect! It looks like you've only visited large amounts of
                    Europe. Maybe a worldwide citytrip is also an idea?
                  </DisplayContent>
                </p>
              </NewCitiesTrigger>
              <TimelineItem>
                <Heading level={3}>
                  <DisplayContent contentKey="exclude-cities-heading">
                    Which cities will it be?
                  </DisplayContent>
                </Heading>
                <FlyExcludedCities
                  solid
                  max={80}
                  destination={this.props.destination}
                  excludedCities={this.props.excludedCities}
                  setExcludedCities={this.props.setExcludedCities}
                />
              </TimelineItem>
              <TimelineItem>
                <ActionList>
                  <People />
                  <Days options={inControlOptions} hideTrigger />
                  <RoomType {...{ hideTrigger: true }} />
                  <AirportComponent {...{ airports, noTimes: true }} />
                </ActionList>
                <Style margin={[[20, 0, 0, 20]]}>
                  <List isText>
                    <ListItem>
                      <DisplayContent contentKey={`1-list-item`}>
                        You fly from Schiphol or Eindhoven airport?
                      </DisplayContent>
                    </ListItem>
                    <ListItem>
                      <DisplayContent contentKey={`2-list-item`}>
                        Depart between 07:00 en 16:00, return 14:00 - 22:00
                      </DisplayContent>
                    </ListItem>
                    <ListItem>
                      <DisplayContent contentKey={`3-list-item`}>
                        Discover a new city inside Europe
                      </DisplayContent>
                    </ListItem>
                  </List>
                </Style>
              </TimelineItem>
              <TimelineItem>
                <Box fullWidthMobile>
                  <Calendar
                    actionList
                    hideTrigger
                    showCheapest={true}
                    prices={prices}
                    loading={loading}
                  />
                </Box>
              </TimelineItem>
            </Timeline>
          </Style>
          <PersonModal />
        </Section>
        <FunnelFooter
          nextStepNo={2}
          nextStepLink={getNameWithTheme('extras')}
          nextStepLinkParams={getParamsWithTheme()}
          nextStepName={
            <DisplayContent edit={true} contentKey="extras">
              Extras
            </DisplayContent>
          }
          stickyStop
          nextStepDisabled={isNaN(this.props.total)}
        />
        <GiftcardModal />
        <FlavourBox
          patternImage={patternImage}
          setInfoRef={this.setInfoRef}
          content={entry.page.content}
        />
        <HowItWorks boxTypeColor={BoxType.celadon} />
        <Section type={SectionType.white}>
          <ListHeader noMarginBottom>
            <Button
              cutOff="none"
              type={TYPE.plain}
              onClick={this.handleDetailsScroll}
            >
              <DisplayContent contentKey="boek-direct" edit={true}>
                Boek direct
              </DisplayContent>
            </Button>
          </ListHeader>
        </Section>
        <FAQ />
      </Page>
    )
  }

  private setInfoRef = (ref: HTMLDivElement) => {
    this.infoSection = ref
  }

  private setDetailsRef = (ref: HTMLDivElement) => {
    this.detailsSection = ref
  }

  private handleInfoScroll = () => {
    if (this.infoSection) {
      this.infoSection.scrollIntoView({ behavior: 'smooth', block: 'start' })
    }
  }

  private handleDetailsScroll = () => {
    if (this.detailsSection) {
      this.detailsSection.scrollIntoView({ behavior: 'smooth', block: 'start' })
    }
  }
}

const ConnectedInControlPage = connect(
  (state: AppState) => ({
    destination: state.funnelOrder.destination,
    patternImage: state.page.patternImage,
    total: state.funnelOrder.total,
    country: state.locale.country,
    excludedCities: state.funnelOrder.excludedCitiesIds,
  }),
  dispatch => ({
    setExcludedCities: (cities: City[]) => {
      dispatch(actions.change('funnelOrder.excludedCitiesIds', cities))
    },
  }),
)(InControlPage)

export default withAirportsAndPrices<EntryProps>(ConnectedInControlPage, [
  QueryKey.month,
  QueryKey.year,
])
